import { Injectable } from '@angular/core';
import { BBService, BBModel } from 'bookingbug-core-js';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { AppConfig } from '../../app.config';
import moment from 'moment';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AmazonService {
  private core = AppConfig.settings.core;
  private apiServer = AppConfig.settings.apiServer;
  member;

  constructor(private http: HttpClient) { }

  async osGetNameDataEncodedApi(postcode: string) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'no-loader': 'no-loader',
        clienttoken: environment.clientToken,
      };
      return await this.http
        .get(`${environment.apiServer}/ordnance_survey/postcode/${postcode}`, {
          headers,
        })
        .toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async getFormSchema(formId: string, company_id, companyName) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'no-loader': 'no-loader',
        clienttoken: environment.clientToken,
      };
      const data = {
        company: company_id,
        client: `${companyName}`,
        form_name: `${formId}`,
      };
      return await this.http
        .post(`${environment.apiServer}/form/schema`, data, { headers })
        .toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }


  async putPermitApplicationOperation(
    data: any,
    company_id,
    companyName,
    operation,
    annual_allowance,
    day_allowance,
    valid_from,
    valid_to,
    status,
    application_type,
    permit_id = undefined
  ) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'no-loader': 'no-loader',
        clienttoken: environment.clientToken,
      };
      let body: any = {};
      body.data = data;
      body.function = operation;
      body.company = company_id;
      body.client = `${companyName}`;
      body.annual_allowance = annual_allowance;
      body['1_day_allowance'] = day_allowance;
      body.status = status;
      body.valid_from = valid_from
      body.valid_to = valid_to
      body.application_type = application_type
      if (permit_id) {
        body.permit_id = permit_id
      }
      return await this.http
        .put(`${environment.apiServer}/permitApplications`, body, { headers })
        .toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async checkPermitApplicationOperation(
    company_id,
    companyName,
    permit_id,
    operation,
    vehicleReg = '',
    email_address = '',
    contact_number = '',
    detailName = '',
    detailSubName = '',
    detailSubSubName = '',
    detailValue = ''
  ) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'no-loader': 'no-loader',
        clienttoken: environment.clientToken,
      };
      let body: any = {};
      body.function = operation;
      body.company = company_id;
      body.permit_id = permit_id;
      body.vehicleReg = vehicleReg;
      body.email_address = email_address;
      body.contact_number = contact_number;
      body.detailName = detailName;
      body.detailSubName = detailSubName;
      body.detailSubSubName = detailSubSubName;
      body.detailValue = detailValue;
      body.client = `${companyName}`;

      return await this.http
        .put(`${environment.apiServer}/permitApplications`, body, { headers })
        .toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }


  async uploadFile(file: object) {
    const headers = {
      'Content-Type': 'application/json',
      'no-loader': 'no-loader',
      clienttoken: environment.clientToken,
    };
    return await this.http
      .post(`${environment.apiServer}/upload`, file, { headers })
      .toPromise();
  }

  async emailTemplateSender(commsData: any) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'no-loader': 'no-loader',
        clienttoken: environment.clientToken,
      };

      return await this.http
        .post(`${environment.apiServer}/emailTemplateSender`, commsData, {
          headers,
        })
        .toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async sendVerificationEmail(token: string, email: string, name: string, reg: string) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        // 'x-company-id': `${companyid}`
        clienttoken: environment.clientToken,
      };
      const data = {
        product: 'dorset.hwrc',
        token: `${token}`,
        email: `${email}&&${reg}`,
        manualToken: true,
        name: `${name}`,
        subject: `${"Permit verification code"}`,
      };
      return await this.http.post(`${environment.apiServer}/client/verify-email`, data, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }


  async verifyToken(token: string) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        // 'x-company-id': `${companyid}`
        clienttoken: environment.clientToken,
      };
      const data = {
        token: `${token}`,
      };
      return await this.http.post(`${environment.apiServer}/client/verify-token`, data, { headers }).toPromise();
    } catch (error) {
      console.error(error);
      return (error as Error).message;
    }
  }
}
